import { render, staticRenderFns } from "./SecondAndFifthArticles.vue?vue&type=template&id=de9f61da&"
import script from "./SecondAndFifthArticles.vue?vue&type=script&lang=js&"
export * from "./SecondAndFifthArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports